<template>
  <ul class="collection drop-shadow">
    <li class="collection-item avatar">
      <img :src="`https://g.foolcdn.com/art/companylogos/mark/${getPrimaryInstrument(company)}.png`"
            class="circle tooltipped"
            alt="logo"
            data-position="top"
            :data-tooltip="company.name"
      >
      <span class="title strong">{{ company.name | pretty }}</span>
      <p>
        <strong>Country: </strong>
        <span class="grey-text">{{ company.country.name }}</span>&nbsp;
        <img :src="`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.1.0/flags/4x3/${company.country.code.toLowerCase()}.svg`"
              height="10"
        >
      </p>
      <p>
        <strong>Geographic Region: </strong>
        <span class="grey-text">{{ company.country.geography.region }}</span>
      </p>
      <p>
        <strong>Sector: </strong>
        <span class="grey-text">{{ company.sector.name }}</span>
      </p>
      <p class="secondary-content">
        <router-link :to="`/tickeradmin/editcompany?company_id=${company.id}`"
                     class="amber-text"
                     v-if="$auth.hasRoles('admin', 'recs-admin')"
        >
          <i class="far fa-edit big" title="Edit Company" />
        </router-link>
      </p>
    </li>
    <li>
      <range-freshness :company-id="company.id" v-if="company.id" />
    </li>
  </ul>
</template>

<script>
import axios from 'axios';
import RangeFreshness from '@/components/RangeFreshness.vue';

export default {
  name: 'CompanyPanel',
  components: { RangeFreshness },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  methods: {
    initTooltip() {
      this.materialize.Tooltip.init(document.querySelectorAll('.tooltipped'), {
        position: 'top',
      });
      document.getElementsByClassName('material-tooltip').forEach(elem => {
        elem.style.borderRadius = '10px';
        elem.style.backgroundColor = '#424242';
      });
    },
    getPrimaryInstrument(company) {
      let primarySymbol = '';
      company.instruments.forEach(instrument => {
        if (instrument.is_primary) {
          primarySymbol = instrument.symbol;
        }
      });
      return primarySymbol;
    },
  },
  mounted() {
    setTimeout(() => {
      this.initTooltip();
    }, 100);
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

li.avatar > img {
  top: 40px;
}

</style>
